export const colorTagsApi = '/api/v1/common/colortag/';
